import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Box,
  Button,
} from '@chakra-ui/react';
import React, { useEffect} from 'react';
import { RiCloseCircleLine } from 'react-icons/ri';
import audio2 from "../../../assets/home/audio2.mp3";


const RejectionNotificationView = (props) => {
  const { rejectedOrderDetails, isRejectOrderOpen, onRejectOrderClose } = props;
  useEffect(() => {
    if (rejectedOrderDetails && isRejectOrderOpen) { // Only play sound if step is greater than 0 (valid step)
      console.log('rejectedOrderDetailsl87987s', rejectedOrderDetails)
      const successAudio = new Audio(audio2);
      successAudio.play().catch((err) => console.error('Audio play error:', err));
    }
  }, [isRejectOrderOpen]);

  const cancelRef = React.useRef();



  return (
    <AlertDialog
      isOpen={isRejectOrderOpen}
      leastDestructiveRef={cancelRef}
      onClose={onRejectOrderClose}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader color="White" fontSize="lg" bg="brand.red">
            Order Rejected
          </AlertDialogHeader>
          <AlertDialogCloseButton color="White" />
          <AlertDialogBody textAlign="center">
            <Box sx={{ width: '40px', margin: 'auto' }} color="brand.red">
              <RiCloseCircleLine fontSize="40px" />
            </Box>
            <Box color="brand.red" mt="3">
              Your order is Rejected!
            </Box>
            <Box>{rejectedOrderDetails.rejectionMsg}</Box>
            <Box mt="4">
              You can always track your orders in the "My Orders List" section
              under the my profile.
            </Box>
          </AlertDialogBody>
          <AlertDialogFooter sx={{ margin: 'auto' }}>
            <Button
              ref={cancelRef}
              onClick={onRejectOrderClose}
              variant="cancel-button"
            >
              Okay
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};
export default RejectionNotificationView;
